import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const avatarImageFn = /* @__PURE__ */ createRecipe('avatar-image', {}, [])

const avatarImageVariantMap = {}

const avatarImageVariantKeys = Object.keys(avatarImageVariantMap)

export const avatarImage = /* @__PURE__ */ Object.assign(memo(avatarImageFn.recipeFn), {
  __recipe__: true,
  __name__: 'avatarImage',
  __getCompoundVariantCss__: avatarImageFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: avatarImageVariantKeys,
  variantMap: avatarImageVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, avatarImageVariantKeys)
  },
  getVariantProps: avatarImageFn.getVariantProps,
})